/**
 * Route that opens the Work Orders create form, optionally preselecting a client.
 * (`params: { clientId }` on NAVIGATE_APP only substitutes ':clientId' tokens, so
 * the client has to be put into the URL here.)
 */
export function workorderCreateRoute(clientId?: unknown): string {
  const id = clientId === undefined || clientId === null ? '' : String(clientId).trim();
  return id ? `/workorders?create=true&clientId=${encodeURIComponent(id)}` : '/workorders?create=true';
}
